import { render } from "./MainDetail.vue?vue&type=template&id=86333e9e&scoped=true"
import script from "./MainDetail.vue?vue&type=script&lang=js"
export * from "./MainDetail.vue?vue&type=script&lang=js"

import "./MainDetail.vue?vue&type=style&index=0&id=86333e9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86333e9e"]])

export default __exports__